import Step4 from '@/Classes/FollowUp/FollowUpPatint';
import Vue from 'vue';
export default {
  data() {
    return {
      openEyeTypeList: [
        { title: '4 به صورت خودبخودی چشم ها باز است', id: 4 },
        { title: '3 در پاسخ به صدا چشم ها را باز می‌کند', id: 3 },
        { title: '2 در پاسخ به درد چشم ها را باز می کند', id: 2 },
        { title: '1 بدون پاسخ', id: 1 },
      ],
      openEyeTypeListUnder5: [
        { title: '4 به صورت خودبخودی چشم ها باز است', id: 4 },
        { title: '3 در پاسخ به صدا / زیر یکسال فریاد زدن', id: 3 },
        { title: '2 در پاسخ به درد چشم ها را باز می کند', id: 2 },
        { title: '1 بدون پاسخ', id: 1 },
      ],
      voiceTypeList: [
        { title: '5 بیدار، هوشیار و ارینته', id: 5 },
        { title: '4 عبارات نامربوط', id: 4 },
        { title: '3 کلمات نامربوط', id: 3 },
        { title: '2 ناله یا اصوات نا مفهوم', id: 2 },
        { title: '1 بدون پاسخ', id: 1 },
      ],
      voiceTypeListUnder5: [
        { title: '5 بیدار، هوشیار و ارینته / عبارات مربوط/ زیر 2 سال صداهای طبیعی', id: 5 },
        { title: '4 کلمات نامربوط / زیر 2 سال گریه تسلی پذیر', id: 4 },
        { title: '3 گریه یا جیغ مداوم', id: 3 },
        { title: '2 ناله یا اصوات نا مفهوم', id: 2 },
        { title: '1 بدون پاسخ', id: 1 },
      ],
      runTypeList: [
        { title: '6 اجرای دستورات / حرکات نرمال', id: 6 },
        { title: '5 تعیین محل تحریک', id: 5 },
        { title: '4 دور شدن از محل درد', id: 4 },
        {
          title: '3 فلکسیون غیرطبیعی اندام های فوقانی همراه با اکستانسیون غیرطبیعی اندام ها',
          id: 3,
        },
        { title: '2 اکستانسیون غیر طبیعی اندام های فوقانی و تحتانی', id: 2 },
        { title: '1 بدون پاسخ', id: 1 },
      ],
      patientVitalSign: new Step4.Step4(
        '',
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        '',
        null,
      ),
      showObservationDate: false,
      tempObservationDate: '',
      eye: null,
      voice: null,
      run: null,
      allVitalSigns: [],
    };
  },
  methods: {
    clearDateTime: function (type) {
      if (type == 'observationDate') {
        this.showObservationDate = false;
        this.patientVitalSign.observationDate = '';
        this.tempObservationDate = '';
      }
    },
    dateTimeChange: function (type) {
      if (type == 'observationDate') {
        if (this.patientVitalSign.observationDate) {
          this.tempObservationDate = Vue.moment(this.patientVitalSign.observationDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      }
    },
    goToStep5: function () {
      if (!this.patientVitalSign.observationDate) {
        this.showErrorAlert('زمان گرفتن علائم حیاتی نمی تواند خالی باشد');
        return;
      }
      if (!this.patientVitalSign.painScale &&
        !this.patientVitalSign.diastolicBloodPressure &&
        !this.patientVitalSign.systolicBloodPressure &&
        !this.patientVitalSign.spO2 &&
        !this.patientVitalSign.bloodSugar &&
        !this.patientVitalSign.pulseRate &&
        !this.patientVitalSign.respiratoryRate &&
        !this.patientVitalSign.temperature) {
        this.showErrorAlert('حداقل یک علائم حیاتی باید وارد شود');
        return;
      }

      if (this.patientVitalSign.diastolicBloodPressure?.length > 0 && !this.patientVitalSign.systolicBloodPressure) {
        this.showErrorAlert('SBP نمی تواند خالی باشد');
        return;
      }
      if (this.patientVitalSign.systolicBloodPressure?.length > 0 && !this.patientVitalSign.diastolicBloodPressure) {
        this.showErrorAlert('DBP نمی تواند خالی باشد');
        return;
      }

      if (this.eye?.id && this.voice?.id && this.run?.id) {
        //محاسبه gcs
        this.patientVitalSign.gcs =
          Number(this.eye.id) + Number(this.voice.id) + Number(this.run.id);
      }
      if (this.eye) {
        this.patientVitalSign.e4 = this.eye.id;
      }
      if (this.voice) {
        this.patientVitalSign.v5 = this.voice.id;
      }
      if (this.run) {
        this.patientVitalSign.m6 = this.run.id;
      }

      const result = this.calculateGapIndex(
        this.patientAge,
        this.patientMonth,
        this.patientVitalSign
      );

      if (result) {
        this.patientVitalSign.gapIndexScore = result.gap;
        this.patientVitalSign.riskAlignment = result.riskAlignment;
      }

      this.patientVitalSign.patientId = Number(this.patientId);
      this.addPatientVitalSignFunction(this.patientVitalSign);
    },
    patientVitalSignAdded: function () {
      try {
        this.$root.$refs.FollowUpPatient.changeTab(2);
        this.$root.$refs.FollowUpPatient.changeTab2Step(1, true);
      } catch (error) { console.log("A error :", error); }
      try {
        this.$root.$refs.ReportFormFollowUp.reloadApiFun(2, this.isGoToNext, 3);
        this.isGoToNext = false
      } catch (error) { console.log("A error :", error); }
    },
    setData: function (data) {
      this.allVitalSigns = [];
      for (let i = 0; i < data.length; i++) {
        let time = '-';
        let gap = '-';
        if (data[i].observationDate) {
          time = Vue.moment(data.observationDate).format('HH:mm:ss');
        }
        if (data[i].gapIndexScore) {
          gap = data[i].gapIndexScore + ' ( ' + data[i].riskAlignment + ' ) ';
        }
        this.allVitalSigns.push({
          gcs: data[i].gcs ? data[i].gcs : '-',
          gap: gap,
          time: time,
          painScale: data[i].painScale ? data[i].painScale : '-',
          sbp: data[i].systolicBloodPressure ? data[i].systolicBloodPressure : '-',
          dbp: data[i].diastolicBloodPressure ? data[i].diastolicBloodPressure : '-',
          spo2: data[i].spO2 ? data[i].spO2 : '-',
          rr: data[i].respiratoryRate ? data[i].respiratoryRate : '-',
          temp: data[i].temperature ? data[i].temperature : '-',
          pr: data[i].pulseRate ? data[i].pulseRate : '-',
          bs: data[i].bloodSugar ? data[i].bloodSugar : '-',
          id: data[i].id,
        });
      }
    },
    backToStep3: function () {
      this.$root.$refs.FollowUpPatient.changeTab1Step(3, true);
    },
    goToNextStep: function () {
      this.$root.$refs.FollowUpPatient.changeTab(2);
      this.$root.$refs.FollowUpPatient.changeTab2Step(1, true);
    },
    calculateGapIndex(patientAge, patientMonth, vitalSigns) {
      let patientMainAge = null;
      if (patientAge) {
        if (patientMonth) {
          patientMainAge = (Number(patientAge) * 12) + Number(patientMonth);
        } else {
          patientMainAge = Number(patientAge) * 12;
        }
      } else {
        if (patientMonth) {
          patientMainAge = Number(patientMonth);
        }
      }

      if (
        vitalSigns?.gcs &&
        vitalSigns?.systolicBloodPressure &&
        patientMainAge
      ) {
        let tempAge = patientMainAge / 12;
        let gap = 0;

        if (tempAge <= 60) {
          gap += 3;
        }
        gap += Number(vitalSigns.gcs);

        if (vitalSigns.systolicBloodPressure >= 120) {
          gap += 6;
        } else if (
          vitalSigns.systolicBloodPressure >= 60 &&
          vitalSigns.systolicBloodPressure < 120
        ) {
          gap += 4;
        }

        let riskAlignment = '';
        if (gap >= 19 && gap <= 24) {
          riskAlignment = 'Mild';
        } else if (gap >= 11 && gap <= 18) {
          riskAlignment = 'Moderate';
        } else if (gap >= 3 && gap <= 10) {
          riskAlignment = 'High';
        }

        return {
          gap: gap,
          riskAlignment: riskAlignment,
        };
      }

      return null;
    },
  },
};
